<template>
    <div>
        <div class="modal hide fade" id="modalGetBarcode" tabindex="-1" role="dialog" aria-labelledby="modalGetBarcode" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Barcode - {{ product.product_no }}</h4>
                        <span>{{ state }}</span>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="barcode" class="col-sm-3 col-form-label text-left">Barcode</label>
                                    <div class="col-sm-9">
                                        <input class="form-control" type="text" id="barcode" v-model="bList.barcode"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="price" class="col-sm-3 col-form-label text-left">Vendor</label>
                                    <div class="col-sm-9">
                                        <select class="form-control" v-model="bList.vendor_no">
                                            <option v-for="v in vendorList" :key="v.id" :value="v.vendor_no">
                                                {{ v.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="save()">Save</button>
                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="cancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductModalBarcode',
  props: ['product', 'id', 'state'],
  computed: {
    ...mapState({
      vendorList: state => state.vendors.vendorList
    }),
    bList: function () {
      var obj
      var index = this.product.barcodes.find(d => d.id === this.id)
      if (index) {
        return index
      } else {
        obj = {
          id: null,
          product_no: null,
          barcode: null,
          vendor_no: null
        }
        return obj
      }
    }
  },
  methods: {
    save () {
      var p = this.product.barcodes.find(d => d.id === this.id)
      var vendor = this.vendorList.find(d => d.vendor_no === p.vendor_no)
      p.vendor = vendor.name
      console.log(p)
    },
    cancel () {
      if (this.state === 'create') {
        var index = this.product.barcodes.findIndex(d => d.id === this.id)
        this.product.barcodes.splice(index, 1)
      }
    }
  }
}
</script>
